export const getUserInitials = (user) => {
  const firstNameInitial = String(user?.vorname || "").trim().charAt(0);
  const lastNameInitial = String(user?.nachname || "").trim().charAt(0);
  const initials = `${firstNameInitial}${lastNameInitial}`.toUpperCase();

  return initials || ".";
};
